import serve from './modules/serve'
import Images from '@/assets'
import Constants from './constant'
export default {
    serve,
    Images,
    Constants,
}